/* eslint-disable no-console */
/* eslint-disable local-rules/no-direct-import */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  MutableRefObject,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import cx from 'classnames';
import { isMobile } from 'react-device-detect';
import ReactDOMServer from 'react-dom/server';
import { Trans, useTranslation } from 'react-i18next';
import MediaQuery from 'react-responsive';
import { useHistory, withRouter } from 'react-router';

import { selectOrderbookPrice } from 'actions/orderbook';
import { closePosition } from 'actions/trade';
import {
  setChartActiveTab,
  setChartCount,
  setIsChartScrolling,
  setShowClosePositionPopup,
  togglePlaceOrderSection,
} from 'actions/tradingView';
import { setTPSLChartNotificationShown, updateUserPreference } from 'actions/user';
import { IChartingLibraryWidget } from 'charting_library_trading_platform/charting_library';
import Button from 'components/button';
import chartStyles from 'components/chart/index.module.scss';
import { StyledButton, Wrapper } from 'components/confirm';
import Modal from 'components/modal';
import mobileWalletStyles from 'components/primaryHeaderMobile/partials/mobileWalletMenu/index.module.scss';
import { MobileModalTitle } from 'components/primaryHeaderMobile/partials/mobileWalletMenu/mobileAssetStyle';
import { useGrowthbookFeatureValue } from 'growthbook';
import {
  calcPrecision,
  getProductUrlByContractType,
  handleInputBlurOnScroll,
  isFutures,
  isOptions,
} from 'helpers';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { device } from 'helpers/screenSizes';
import Theme from 'helpers/theme';
import { useTheme } from 'hooks';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import { useScrollDetection } from 'hooks/useScrollDetection';
import {
  allOpenPositionsSelector,
  futuresOpenPositionsSelector,
} from 'selectors/holdingsSelectors';
import {
  isTPSLChartNotificationShownSelector,
  userSelector,
} from 'selectors/otherSelectors';
import { socketActiveSelector } from 'selectors/socketSelectors';
import {
  chartProductsBySelectedContractTypeSelector,
  selectedProductSelector,
} from 'selectors/tradeSelectors';
import {
  chartActiveTabSelector,
  futuresChartCountSelector,
  shouldShowClosePositionPopupSelector,
} from 'selectors/tradingViewSelector';
import { useAppDispatch, useAppSelector } from 'storeHooks';
import { CancelIcon, CrossModalCloseIcon } from 'styles/assets/icons';
import { OpenPosition } from 'types/IOpenPosition';

import { widget, version } from '../../charting_library_trading_platform';
import {
  SOURCE_FOR_MIXPANEL_EVENTS,
  STORAGE_KEYS,
  urlContractTypeRedirection,
} from '../../constants';
import { CHART_TABS } from './chart.constants';
import { TvStyle } from './chart_style';
import { brokerCallbacks, getChartBroker } from './GlobalBrokerObject';
import { getTvSymbol } from './helper';
import OpenOrdersWidget from './openOrderWidgets';
import OpenPositionLine, { createOrderFromOpenPosition } from './openPositionLine';
import OpenStopOrderLine from './openStopOrderWidgets';
import { DisplayOrdersSVGIconString, NewTabSvgString } from './tradingSvgIcons';
import chartConfig from './tradingViewChartConfig';

interface FuturesTradingViewContainerProps {
  fullScreen: boolean;
}

const FuturesTradingViewContainer = (props: FuturesTradingViewContainerProps) => {
  const { fullScreen } = props;
  const { t } = useTranslation(['trading', 'common']);
  const { isDarkTheme, chartBackgroundColor, activeTheme } = useTheme();
  const theme = Theme(activeTheme);

  const [isChartReady, setChartReady] = useState<boolean>(false);
  const [isOpen, showModal] = useState<boolean>(false);
  const [positionSide, setPositionSide] = useState<string>('');
  const [showOrders, setShowOrders] = useState<boolean>(true);
  const shouldShowClosePositionPopup = useAppSelector(
    shouldShowClosePositionPopupSelector
  );
  const isChartBrokerEnabled = useGrowthbookFeatureValue('is_chart_broker_enabled');

  const widgetRef = useRef<null | IChartingLibraryWidget>(null);
  const orderPriceRef = useRef<null | string>(null);
  const updatePriceRef = useRef<null | Function>(null);
  const newTabUrlRef = useRef<null | string>(null);
  const tvWidgetElementRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  const showOrdersButtonRef = useRef<HTMLElement | null>(null);
  const newTabButtonRef = useRef<HTMLElement | null>(null);
  const prevLayoutCountRef = useRef<number | undefined>(undefined);

  const chartCount = useAppSelector(futuresChartCountSelector);
  const selectedProduct = useAppSelector(state => selectedProductSelector(state));
  const products = useAppSelector(chartProductsBySelectedContractTypeSelector);
  const socketActive = useAppSelector(socketActiveSelector);
  const user = useAppSelector(userSelector);
  const activeTab = useAppSelector(chartActiveTabSelector);

  const [activeChartSymbol, setActiveChartSymbol] = useState<string | null>(
    selectedProduct?.symbol ?? null
  );
  const openPosition = useAppSelector(state => {
    const openPositionForActiveSymbol = allOpenPositionsSelector(state).find(
      (position: OpenPosition) =>
        activeChartSymbol?.includes(position?.product?.symbol ?? '')
    );
    return openPositionForActiveSymbol ?? null;
  });

  const allFuturesOpenPositions = useAppSelector(futuresOpenPositionsSelector);
  const isTPSLChartNotificationShown = useAppSelector(
    isTPSLChartNotificationShownSelector
  );

  const { whenAboveMd } = useCustomMediaQuery();

  const appDispatch = useAppDispatch();
  const history = useHistory();
  const { attachTo } = useScrollDetection(
    isScrolling => {
      appDispatch(setIsChartScrolling(isScrolling));
    },
    { debounceTime: 500 }
  );

  const isNewTab = window.location.href.indexOf('/app/tradingview') > -1;

  const currentActiveTab = activeTab;

  const findProductBySymbol = (
    productList: Record<string, any>,
    symbolToFind: string
  ) => {
    return Object.values(productList).find(product => product.symbol === symbolToFind);
  };

  const symbol = useMemo(() => {
    console.log(
      'DEBUG FUTURES',
      selectedProduct?.symbol,
      currentActiveTab,
      selectedProduct?.spot_index?.symbol
    );
    return getTvSymbol(
      selectedProduct?.symbol,
      currentActiveTab,
      selectedProduct?.spot_index?.symbol
    );
  }, [selectedProduct?.symbol, currentActiveTab, selectedProduct?.spot_index?.symbol]);

  // TODO : refactor this using useCallback to be intitated only on product change
  const initiateCharts = () => {
    if (!socketActive) {
      return;
    }
    const savedChartProperties = localStorage.getItem(
      'tradingview.chartproperties.mainSeriesProperties'
    );

    console.log('DEBUG FUTURES: Creating futures widget', version());
    const widgetOptions = chartConfig({
      symbol,
      interval: JSON.parse(savedChartProperties || '{}').interval || '60',
      themeObj: theme,
      activeTab: currentActiveTab,
      activeTheme: isDarkTheme ? 'dark' : 'light',
      userId: user?.id ? `${user.id}_futures` : 'futures',
      contractType: selectedProduct?.contract_type,
      isNewTab,
      whenBelowMd: !whenAboveMd,
      container: 'tv_chart_container_futures',
      containerType: 'futures',
    });

    console.log('DEBUG FUTURES', theme, widgetOptions);

    // eslint-disable-next-line new-cap
    const tvWidget: IChartingLibraryWidget = new widget(widgetOptions);
    tvWidget?.onChartReady(() => {
      widgetRef.current = tvWidget;
      setChartReady(true);

      // apply iframe event listeners
      const iframe = tvWidgetElementRef.current?.firstElementChild as HTMLIFrameElement;
      if (iframe?.contentDocument) {
        let unsubscribeActiveChartEl;
        let unsubscribepriceAxisEl;
        // only for mobile devices
        if (!whenAboveMd) {
          window.tvChartWidget = tvWidget as any;
          // eslint-disable-next-line no-underscore-dangle
          const activeChartEl = (tvWidget.activeChart() as any)?._chartWidget?._mainDiv;
          // ? mousewheel event of activeChartEl doesnt work on price axis, so adding one on it
          const priceAxisEl = activeChartEl?.querySelector('.price-axis');
          unsubscribeActiveChartEl = attachTo(activeChartEl);
          unsubscribepriceAxisEl = attachTo(priceAxisEl, { eventTypes: ['wheel'] });
        }

        const unsubscribe = handleInputBlurOnScroll(iframe.contentDocument);
        iframe.contentDocument?.addEventListener('beforeunload', () => {
          unsubscribe();
          unsubscribeActiveChartEl?.();
          unsubscribepriceAxisEl?.();
        });
      }
      getChartBroker()?.setActiveSymbol?.(symbol);
      tvWidget?.activeChart()?.setSymbol(symbol);
      tvWidget
        ?.activeChart()
        ?.getPanes()[0]
        .getMainSourcePriceScale()
        ?.setAutoScale(true);
      tvWidget?.unloadUnusedCharts();

      tvWidget.applyOverrides({
        // udpates background color of the chart
        'paneProperties.backgroundGradientStartColor': chartBackgroundColor,
        'paneProperties.backgroundGradientEndColor': chartBackgroundColor,
        'mainSeriesProperties.statusViewStyle.showInterval': true,
        'mainSeriesProperties.statusViewStyle.symbolTextSource': 'ticker',
      });

      tvWidget.headerReady().then(() => {
        if (user?.id !== '') {
          const button = tvWidget.createButton({ useTradingViewStyle: false });
          button.addEventListener('click', () =>
            setShowOrders((state: boolean) => {
              return !state;
            })
          );
          button.setAttribute('title', t('trading:header.toggleShowHidePositions'));
          button.innerHTML = ReactDOMServer.renderToStaticMarkup(
            <DisplayOrdersSVGIconString
              strokeColor={isDarkTheme ? '#E1E1E2' : '#121214'}
            />
          );
          showOrdersButtonRef.current = button;
        }

        if (!isNewTab && whenAboveMd) {
          const newTabButton = tvWidget.createButton();
          newTabButton.addEventListener('click', () =>
            newTabUrlRef.current ? window.open(newTabUrlRef.current) : null
          );
          newTabButton.setAttribute('title', t('trading:header.openInNewTab'));
          newTabButton.innerHTML = ReactDOMServer.renderToStaticMarkup(
            <NewTabSvgString strokeColor={isDarkTheme ? '#E1E1E2' : '#121214'} />
          );
          newTabButtonRef.current = newTabButton;
        }
      });
    });

    // eslint-disable-next-line consistent-return
    return widgetOptions;
  };

  // Extract the common redirect logic
  const handleProductRedirect = useCallback(() => {
    const tvWidget = widgetRef.current;
    if (!tvWidget) return;

    const chartSymbol = tvWidget.activeChart()?.symbol() ?? selectedProduct?.symbol ?? '';
    setActiveChartSymbol(chartSymbol);

    const productData = findProductBySymbol(products, chartSymbol.replace('MARK:', ''));

    console.log('DEBUG FUTURES', productData);

    if (!productData) {
      appDispatch(togglePlaceOrderSection(false));
      return;
    }

    const underlyingAsset = productData?.underlying_asset?.symbol || '';
    const redirectLink = isNewTab
      ? `/tradingview/${
          chartSymbol.includes('MARK:') ? CHART_TABS.MARK_CHART : CHART_TABS.PRICE_CHART
        }/${urlContractTypeRedirection(productData?.contract_type)}/${
          productData?.underlying_asset?.symbol
        }/${chartSymbol}`
      : getProductUrlByContractType(
          productData?.contract_type,
          underlyingAsset,
          chartSymbol.replace('MARK:', '')
        );

    appDispatch(togglePlaceOrderSection(true));

    if (chartSymbol.includes('MARK:')) {
      appDispatch(setChartActiveTab(CHART_TABS.MARK_CHART));
    } else if (chartSymbol.includes('.DE')) {
      appDispatch(setChartActiveTab(CHART_TABS.INDEX_PRICE_CHART));
    } else {
      appDispatch(setChartActiveTab(CHART_TABS.PRICE_CHART));
    }

    history.push(redirectLink);
  }, [selectedProduct, products, isNewTab, appDispatch, history]);

  useEffect(() => {
    prevLayoutCountRef.current = chartCount;
  }, [chartCount]);

  useEffect(() => {
    const tvWidget = widgetRef.current;

    // ! there is no unsubscribe function returned from below subscriptions, so not unsubscribing
    if (isChartReady && tvWidget) {
      tvWidget
        ?.activeChart()
        ?.onIntervalChanged()
        ?.subscribe(null, () => {
          tvWidget
            ?.activeChart()
            ?.getPanes()[0]
            .getMainSourcePriceScale()
            ?.setAutoScale(true);
        });

      // Auto-save subscription
      tvWidget?.subscribe('onAutoSaveNeeded', () => {
        tvWidget?.saveChartToServer(
          () => console.log('DEBUG FUTURES: saveChartToServer'),
          e => console.error('DEBUG FUTURES: saveChartToServer error', e),
          {
            chartName: `${symbol}_futures`,
          }
        );
      });

      tvWidget
        ?.activeChart()
        ?.onSymbolChanged()
        ?.subscribe(null, () => {
          console.log(
            'DEBUG FUTURES: onSymbolChanged',
            tvWidget?.activeChart()?.symbol()
          );
          getChartBroker()?.setActiveSymbol?.(tvWidget?.activeChart()?.symbol());
          handleProductRedirect();
        });

      // Active chart change subscription
      tvWidget?.subscribe('activeChartChanged', () => {
        handleProductRedirect();
        tvWidget
          ?.activeChart()
          ?.onSymbolChanged()
          ?.subscribe(null, () => {
            console.log(
              'DEBUG FUTURES: onSymbolChanged',
              tvWidget?.activeChart()?.symbol()
            );
            handleProductRedirect();
          });
      });

      // Layout change subscription
      tvWidget?.subscribe('layout_changed', () => {
        console.log('DEBUG FUTURES: Layout changed', tvWidget?.chartsCount());
        if (tvWidget?.chartsCount() === 1) {
          tvWidget
            ?.activeChart()
            ?.setSymbol(
              getTvSymbol(
                selectedProduct?.symbol ?? '',
                currentActiveTab,
                selectedProduct?.spot_index?.symbol ?? ''
              )
            );
        }
        appDispatch(
          setChartCount({ containerType: 'futures', chartCount: tvWidget?.chartsCount() })
        );
        trackMixpanelEvent('Chart Layout Changed - Trade - Chart', {
          is_mobile: isMobile,
          current_chart_layout: prevLayoutCountRef.current || 1,
          selected_chart_layout: tvWidget?.chartsCount(),
          widget_type: 'futures',
        });
      });

      // Cross-hair and mouse events (desktop only)
      if (whenAboveMd) {
        tvWidget
          ?.activeChart()
          .crossHairMoved()
          .subscribe(null, ({ price }: { price: number }) => {
            const precision = calcPrecision(selectedProduct?.tick_size);
            orderPriceRef.current = price.toFixed(precision);
          });

        tvWidget?.subscribe('mouse_up', () => {
          updatePriceRef.current?.();
        });
      }
    }
  }, [isChartReady]);

  // useEffect to update newTabUrlRef
  useEffect(() => {
    const route = window.location.pathname.replace('/app', '').replace('/trade', '');
    newTabUrlRef.current = `/app/tradingview/${currentActiveTab}${route}`;
  }, [currentActiveTab, selectedProduct?.id]);

  // to initially mount the chart
  useEffect(() => {
    initiateCharts();
    return () => {
      window.tvChartWidget?.remove();
      delete window.tvChartWidget;
      window.sessionStorage.removeItem(STORAGE_KEYS.CHART_LAST_SUBSCRIPTION_ID);
    };
  }, []);

  // change symbol when selected product changes
  useEffect(() => {
    if (selectedProduct && socketActive && widgetRef.current && isChartReady) {
      widgetRef.current?.activeChart()?.setSymbol(symbol ?? '');

      widgetRef.current
        ?.activeChart()
        ?.getPanes()[0]
        .getMainSourcePriceScale()
        ?.setAutoScale(true);

      appDispatch(
        setChartCount({
          containerType: 'futures',
          chartCount: widgetRef.current?.chartsCount(),
        })
      );

      if (
        currentActiveTab === CHART_TABS.PRICE_CHART ||
        currentActiveTab === CHART_TABS.MARK_CHART
      ) {
        setShowOrders(true);
      }

      if (
        currentActiveTab === CHART_TABS.PRICE_CHART ||
        (currentActiveTab === CHART_TABS.MARK_CHART &&
          (isFutures(selectedProduct?.contract_type) ||
            isOptions(selectedProduct?.contract_type)))
      ) {
        updatePriceRef.current = () => {
          appDispatch(
            selectOrderbookPrice({
              price: orderPriceRef.current,
              productId: selectedProduct?.id,
              fromTradingView: user?.preferences?.tradeToOrderBookedPriceFill,
            })
          );
        };
      }
    }
  }, [selectedProduct, currentActiveTab, isChartReady, symbol]);

  // Apply theme changes
  useEffect(() => {
    if (selectedProduct && socketActive && widgetRef.current && isChartReady) {
      widgetRef.current?.changeTheme(isDarkTheme ? 'dark' : 'light');

      if (showOrdersButtonRef.current) {
        showOrdersButtonRef.current.setAttribute(
          'title',
          t('trading:header.toggleShowHidePositions')
        );
        showOrdersButtonRef.current.innerHTML = ReactDOMServer.renderToStaticMarkup(
          <DisplayOrdersSVGIconString strokeColor={isDarkTheme ? '#E1E1E2' : '#121214'} />
        );
      }

      if (newTabButtonRef.current) {
        newTabButtonRef.current.setAttribute('title', t('trading:header.openInNewTab'));
        newTabButtonRef.current.innerHTML = ReactDOMServer.renderToStaticMarkup(
          <NewTabSvgString strokeColor={isDarkTheme ? '#E1E1E2' : '#121214'} />
        );
      }
    }
  }, [activeTheme]);

  useEffect(() => {
    if (
      isChartBrokerEnabled &&
      !isTPSLChartNotificationShown &&
      allFuturesOpenPositions.length > 0
    ) {
      appDispatch(setTPSLChartNotificationShown(true));
      setTimeout(() => {
        getChartBroker()?.showNotification?.(
          'Place TP/SL on charts',
          `${
            whenAboveMd ? 'Hover' : 'Tap'
          } on position line to reveal TP/SL button and drag them to set TP/SL orders`
        );
      }, 2500);
      appDispatch(
        updateUserPreference(
          { preferences: { isTPSLChartNotificationShown: true } },
          { disable_notification: true }
        )
      );
    }
  }, [allFuturesOpenPositions, isTPSLChartNotificationShown, isChartBrokerEnabled]);

  const onClose = () => {
    setPositionSide(openPosition?.size > 0 ? 'Long' : 'Short');
    showModal(true);
  };

  const onClickYes = () => {
    if (!openPosition) {
      showModal(false);
      appDispatch(setShowClosePositionPopup(false));
      brokerCallbacks?.closePosition?.reject?.('Position not found');
      return;
    }
    const order = createOrderFromOpenPosition(openPosition);
    appDispatch(
      closePosition(
        order,
        {
          totalPositions: openPosition.size,
          chart: true,
          orderProps: order.orderProps,
          precision: order.precision,
          source: SOURCE_FOR_MIXPANEL_EVENTS.CHART,
        },
        (result, error) => {
          if (error) {
            brokerCallbacks?.closePosition?.reject?.(error);
          } else {
            brokerCallbacks?.closePosition?.resolve?.(true);
          }
        }
      )
    );
    trackMixpanelEvent('Position Closed - Trade - Table', {
      type: 'market_order',
      quantity: openPosition?.size,
      share_of_total_positions: 1,
      type_of_position: openPosition?.size > 0 ? 'long' : 'short',
      product_type: openPosition?.product?.contract_type,
      source: SOURCE_FOR_MIXPANEL_EVENTS.CHART,
    });
    setPositionSide('');
    showModal(false);
    appDispatch(setShowClosePositionPopup(false));
  };

  const onCancelClose = () => {
    showModal(false);
    appDispatch(setShowClosePositionPopup(false));
    brokerCallbacks?.closePosition?.resolve?.(false);
  };

  const isChartOrdersVisible = showOrders && user?.id !== '' && widgetRef?.current;

  return (
    <>
      <TvStyle
        // ref={tvWidgetElementRef}
        id="tv_chart_container_futures"
        className={cx(
          'tv_chart_container',
          fullScreen ? 'mobile-full-screen w-100vh' : ''
        )}
      />
      {isChartOrdersVisible && (
        <>
          {!isChartBrokerEnabled && (
            <OpenPositionLine
              widgetRef={widgetRef}
              isNewTab={isNewTab}
              onClose={onClose}
              isChartReady={isChartReady}
              currentActiveTab={currentActiveTab}
              activeChartSymbol={activeChartSymbol}
            />
          )}
          <OpenStopOrderLine
            widgetRef={widgetRef}
            isNewTab={isNewTab}
            isChartReady={isChartReady}
            currentActiveTab={currentActiveTab}
            activeChartSymbol={activeChartSymbol}
            containerType="futures"
          />
          <OpenOrdersWidget
            widgetRef={widgetRef}
            isNewTab={isNewTab}
            isChartReady={isChartReady}
            currentActiveTab={currentActiveTab}
            activeChartSymbol={activeChartSymbol}
          />
        </>
      )}

      <MediaQuery query={device.down.md}>
        <Modal
          isOpen={isOpen || shouldShowClosePositionPopup}
          onRequestClose={showModal}
          shouldCloseOnOverlayClick
          shouldCloseOnEsc={false}
          className="footer-common-modal"
          classOverlayName="footer-common-modal-overlay"
        >
          <Wrapper>
            <MobileModalTitle className={mobileWalletStyles['modal-title']}>
              <button type="button" data-testid="close-modal" onClick={onCancelClose}>
                <CancelIcon />
              </button>
            </MobileModalTitle>
            <div className="confirm-text">
              <Trans
                i18nKey="common:close_position"
                values={{
                  product: openPosition?.product_symbol,
                  side: positionSide,
                }}
              >
                <span className={`side-${positionSide.toLowerCase()}`} />
                <span className="product-name" />
              </Trans>
            </div>
            <div className={chartStyles['yes-button']}>
              <Button
                data-testid="mobile-close-position-yes-button"
                style={{
                  margin: '20px',
                  width: '90%',
                }}
                primary
                onClick={onClickYes}
                className="mobile-close-button"
              >
                {t('common:market_close')}
              </Button>
            </div>
          </Wrapper>
        </Modal>
      </MediaQuery>
      <MediaQuery query={device.up.md}>
        <Modal
          isOpen={isOpen || shouldShowClosePositionPopup}
          onRequestClose={showModal}
          style={{
            padding: 0,
            zIndex: 99999,
            content: {
              top: '0 !important',
              height: '100%',
              overflow: 'hidden',
            },
          }}
        >
          <Wrapper className="close-position">
            <span
              data-testid="futures-close-position-modal-close-icon"
              className="close-icon"
              onClick={onCancelClose}
              role="button"
              onKeyPress={() => {}}
              tabIndex={0}
            >
              <CrossModalCloseIcon />
            </span>
            <div className="confirm-text">
              <Trans
                i18nKey="common:close_position"
                values={{
                  product: openPosition?.product_symbol,
                  side: positionSide,
                }}
              >
                <span className={`side-${positionSide.toLowerCase()}`} />
                <span className="product-name" />
              </Trans>
            </div>
            <div className="buttons">
              <StyledButton
                data-testid="desktop-close-position-yes-button"
                className="confirm-ok-button"
                primary
                onClick={onClickYes}
              >
                {t('common:market_close')}
              </StyledButton>
              <StyledButton
                data-testid="desktop-close-position-cancel-button"
                className="confirm-no-button"
                primary
                onClick={onCancelClose}
              >
                {t('common:cancel')}
              </StyledButton>
            </div>
          </Wrapper>
        </Modal>
      </MediaQuery>
    </>
  );
};

export default withRouter(FuturesTradingViewContainer);
